<template>
  <v-btn
    text
    color="primary"
    :loading="loading"
    data-testid="switch-to-beta-btn"
    @click="switchToBeta">
    {{ $t('switchToBeta.btn') }}
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'switch-to-beta',
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      switchToCallpanelV2: 'sessions/switchToCallpanelV2'
    }),
    switchToBeta: async function () {
      this.loading = true
      try {
        const redirectUri = await this.switchToCallpanelV2()
        if (redirectUri) {
          window.location.href = redirectUri
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
</style>
